'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dPin$0024 from "./presto.types$-Pin$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$43(outer) {
  this.bOz = null;
  this.bOx = null;
  this.bOy = false;
  this.bOv = null;
  this.bOw = false;
  this.bOA = false;
  this.bOB = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bOz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$43 as $c_Lpresto_UsersView$$anon$43 };
$p = $c_Lpresto_UsersView$$anon$43.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$43;
/** @constructor */
function $h_Lpresto_UsersView$$anon$43() {
}
export { $h_Lpresto_UsersView$$anon$43 as $h_Lpresto_UsersView$$anon$43 };
$h_Lpresto_UsersView$$anon$43.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bOz;
});
$p.t = (function() {
  if ((!this.bOy)) {
    this.bOx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("pin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bOy = true;
  }
  return this.bOx;
});
$p.ae = (function() {
  if ((!this.bOw)) {
    this.bOv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPin$0024.$m_Lpresto_types$Pin$().zf(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bOw = true;
  }
  return this.bOv;
});
$p.w = (function() {
  if ((!this.bOB)) {
    this.bOA = false;
    this.bOB = true;
  }
  return this.bOA;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$43 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$43, "presto.UsersView$$anon$43", ({
  UT: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$43 as $d_Lpresto_UsersView$$anon$43 };
//# sourceMappingURL=presto.-Users-View$$anon$43.js.map
